import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-message-circle-icon]',
  template: `
    <svg:path
      d="M12 4C7.58173 4 4.00001 7.58172 4.00001 12C4.00001 13.0204 4.19056 13.9939 4.5371 14.8886C4.65545 15.1941 4.70905 15.5395 4.66341 15.8951L4.16681 19.7643L7.48699 19.1431C7.92018 19.0621 8.34734 19.131 8.71381 19.2963C9.71506 19.7481 10.8268 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2.00001 12C2.00001 6.47715 6.47716 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22C10.5376 22 9.14596 21.6854 7.89129 21.1194C7.86853 21.1091 7.85566 21.1091 7.85364 21.1092L3.18392 21.9829C2.86955 22.0418 2.546 21.9467 2.31345 21.7271C2.08091 21.5075 1.96743 21.1899 2.00815 20.8727L2.67956 15.6417C2.67956 15.6417 2.67956 15.6416 2.67956 15.6414C2.67957 15.6398 2.67932 15.6295 2.67213 15.611C2.23776 14.4896 2.00001 13.2714 2.00001 12Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageCircleIcon {
  readonly viewBox = input<string>('0 0 24 24');
}
